import React from "react";

const STATUS_COLORS = {
  pending: {
    dot: "#F6C544", // Toucan Yellow
    bg: "#F6F6F6",
    text: "#0A2433", // Deep Blue
  },
  ongoing: {
    dot: "#00C2C7", // Teal
    bg: "#E6FAFC",
    text: "#0A2433",
  },
  completed: {
    dot: "#00C2C7",
    bg: "#E6FAFC",
    text: "#0A2433",
  },
  upcoming: {
    dot: "#F5BE28", // Orange
    bg: "#FFF6E6",
    text: "#0A2433",
  },
  approved: {
    dot: "#4CAF50", // Green
    bg: "#E8F5E9",
    text: "#0A2433",
  },
  paid: {
    dot: "#4CAF50", // Green
    bg: "#E8F5E9",
    text: "#0A2433",
  },
};

export default function StatusBadge({ status = "pending", sidebar = false }) {
  const s = status.toLowerCase();
  const { dot, bg, text } = STATUS_COLORS[s] || STATUS_COLORS.pending;

  const updatedBg = sidebar ? bg : "transparent";

  return (
    <div
      className={`flex items-center gap-2 ${
        sidebar ? "px-6 py-3" : "p-0"
      } rounded-2xl text-[16px] font-semibold justify-center`}
      style={{ backgroundColor: updatedBg, color: text }}
    >
      <span
        className="inline-block w-3 h-3 rounded-full"
        style={{ backgroundColor: dot }}
      />
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </div>
  );
}
